<div class="container-fluid">
  <div class="page-head">
    <h1 class="page-title">Admin - Accounting</h1>
  </div>

  <p class="text-secondary mb-4">
    Click on an accounting system below to view that system's AP vendor records.
  </p>

  @if (ApConfigs && ApConfigs.length > 0) {
    <!-- VPDW-3111: g-3 (16px gutter) so cards have consistent
         horizontal + vertical spacing, no more "stuck-together" feel.
         Each card is col-md-6 / col-lg-4 / col-xl-3 so they
         responsively wrap into 2/3/4 columns. -->
    <div class="row g-3 accounting-cards">
      @for (config of ApConfigs; track config) {
        <div class="col-md-6 col-lg-4 col-xl-3">
          <app-display-card class="accounting-card">
            <h3 class="accounting-card__title">{{ config.apSystem }}</h3>
            <dl class="accounting-card__list">
              <dt>Display name</dt>
              <dd>{{ config.apDisplayName }}</dd>
              <dt>Next vendor sync</dt>
              <dd>{{ config.nextVendorSync | date: 'MM/dd/yyyy' }}</dd>
              <dt>Last vendor sync</dt>
              <dd>{{ config.lastVendorSync | date: 'MM/dd/yyyy' }}</dd>
              <dt>Sync interval</dt>
              <dd>{{ config.syncInterval }}</dd>
              <dt>Retry interval</dt>
              <dd>{{ config.retryInterval }}</dd>
            </dl>
            <div class="accounting-card__footer">
              <button
                class="btn btn-primary"
                (click)="viewApVendors(config.id)"
              >
                View
              </button>
            </div>
          </app-display-card>
        </div>
      }
    </div>
  }
</div>
